import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class PaymentTerm extends BaseEntity{
    
    paymentTermCode : string;
    name : string;
    discount : number;
    rank : number;
    minimumAmount : number;
    maximumAmount : number;
    fixedTaxApplyable : boolean;
    fixedTaxRate : number;
    fixedTaxMinimum : number;
    fixedTaxMaximum : number;
    fixedTaxRoundingDecimal : boolean;
    impactFinancialBalance : boolean
    
    
}
